import React, { memo, useLayoutEffect } from 'react';
import { isNullOrUndefined } from 'shared/utils/null.utils';

interface IConditionalRenderProps {
  condition: (() => boolean) | boolean;
  children: any;
  onRender?: () => void;
  elseRender?: () => JSX.Element;
}

const ConditionalRender = memo((props: IConditionalRenderProps) => {
  
  const resolveCondition = (): boolean => {
    return typeof props.condition === 'boolean' ? props.condition : props.condition();
  }

  useLayoutEffect(() => {
    if(!isNullOrUndefined(props.onRender))
      props.onRender(); 
  }, [props]);

  return (
    <React.Fragment>
      {resolveCondition() && props.children}
      {!resolveCondition() && props.elseRender && <props.elseRender />}
    </React.Fragment>
  )
});

export default ConditionalRender;